// extracted by mini-css-extract-plugin
export default {"nav":"SideNav_nav__EPkJ6","header":"SideNav_header__M8Atl","container":"SideNav_container__oJa1T","containerRef":"SideNav_containerRef__2vOpn","open":"SideNav_open__YPhL+"};